import { features } from "@/data/features"
import { IconCard } from "@/components/common/IconCard"

export function Features() {
  return (
    <section id="features" className="py-24 bg-canvas">
      <div className="max-w-5xl mx-auto px-4 sm:px-8">
        <div className="text-center mb-16">
          <p className="text-caption text-primary mb-3">功能</p>
          <h2 className="text-heading text-ink mb-4">
            一套完整的错题学习工具
          </h2>
          <p className="text-body text-ink-soft max-w-xl mx-auto">
            从录入到复盘，每个环节都为「不再错」而设计。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <IconCard
              key={feature.title}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              delay={index * 0.05}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
